import { __awaiter } from 'tslib';
import { windowPostServe, parentPostServe, parentPostRequest, windowPostRequest } from '@navify-platform/post-message';

const IFRAME_LINK_REQUEST_CONNECT = 'connect';
const IFRAME_LINK_REQUEST_CONNECT_TIMEOUT = 2000; // 2 seconds
const IFRAME_LINK_REQUEST_DISCONNECT = 'disconnect';
const IFRAME_LINK_REQUEST_DISCONNECT_TIMEOUT = 2000; // 2 seconds
const IFRAME_LINK_RESPONSE_CONNECTED = 'connected';
const IFRAME_LINK_RESPONSE_DISCONNECTED = 'disconnected';
/**
 * @hidden
 */
class IframeLink {
    constructor(asParentHandler, asWindowHandler, options = {}) {
        this.asParentHandler = asParentHandler;
        this.asWindowHandler = asWindowHandler;
        this.options = options;
        this.parentLink = null;
        this.windowLinks = [];
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.initAsParent();
            yield this.initAsWindow();
        });
    }
    initAsParent() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.options.disableAsParent) {
                return null;
            }
            this.windowPostServer = windowPostServe((request, origin, source, extras) => __awaiter(this, void 0, void 0, function* () {
                if (request === IFRAME_LINK_REQUEST_CONNECT) {
                    this.windowLinks.push({ origin, source, extras });
                    return IFRAME_LINK_RESPONSE_CONNECTED;
                }
                if (request === IFRAME_LINK_REQUEST_DISCONNECT) {
                    this.windowLinks.splice(this.windowLinks.findIndex((link) => link.source === source), 1);
                    return IFRAME_LINK_RESPONSE_DISCONNECTED;
                }
                if (this.asParentHandler) {
                    return yield this.asParentHandler(request, origin, source, extras);
                }
                return null;
            }), null);
        });
    }
    initAsWindow() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.options.disableAsWindow || !checkIfIframed()) {
                return null;
            }
            this.parentPostServer = parentPostServe((request, origin, source, extras) => __awaiter(this, void 0, void 0, function* () {
                if (this.asWindowHandler) {
                    return yield this.asWindowHandler(request, origin, source, extras);
                }
                return null;
            }));
            try {
                const { response, origin, source, extras } = yield parentPostRequest(IFRAME_LINK_REQUEST_CONNECT, { timeout: IFRAME_LINK_REQUEST_CONNECT_TIMEOUT });
                if (response === IFRAME_LINK_RESPONSE_CONNECTED) {
                    this.parentLink = { origin, source, extras };
                }
            }
            catch (error) {
                // noop
            }
        });
    }
    destroy() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.destroyAsParent();
            yield this.destroyAsWindow();
        });
    }
    destroyAsParent() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.options.disableAsParent) {
                return null;
            }
            this.windowPostServer.destroy();
        });
    }
    destroyAsWindow() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.options.disableAsWindow || !checkIfIframed()) {
                return null;
            }
            this.parentPostServer.destroy();
            try {
                yield parentPostRequest(IFRAME_LINK_REQUEST_DISCONNECT, { timeout: IFRAME_LINK_REQUEST_DISCONNECT_TIMEOUT });
            }
            catch (error) {
                // noop
            }
        });
    }
    hasParent() {
        return !!this.parentLink;
    }
    parentRequest(request, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.options.disableAsWindow) {
                return null;
            }
            try {
                const result = yield parentPostRequest(request, options);
                return result;
            }
            catch (error) {
                return error;
            }
        });
    }
    hasWindows() {
        return !!this.windowLinks.length;
    }
    windowsRequest(request, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.options.disableAsParent) {
                return null;
            }
            return Promise.all(this.windowLinks.map(({ source }) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const result = yield windowPostRequest(request, source, options);
                    return result;
                }
                catch (error) {
                    return error;
                }
            })));
        });
    }
}
/**
 * @hidden
 */
const checkIfIframed = () => {
    return window.parent !== window;
};

/**
 * Generated bundle index. Do not edit.
 */

export { IframeLink, checkIfIframed };

